import { Box } from '@/components/Box/Box';
import { Typography } from '@/components/Typography/Typography';
import { TableNew } from '@/components-new/TableNew/TableNew';
import { TableHeadNew } from '@/components-new/TableNew/TableHeadNew';
import { TableHeadCellNew } from '@/components-new/TableNew/TableHeadCellNew';
import { TableBodyNew, TableCellNew, TableRowNew } from '@/components-new/TableNew/styles';
import { formatDate, FULL_DATE_TIME_FORMAT } from '@/helpers/dateHelpers/dateHelpers';
import { AuditEventType } from '@/types/auditLogTypes';
import { SOURCE_LABEL } from '../const/const';
import { Mono, SourceTag } from '../styles';
import { ButtonNew } from '@/components-new/ButtonNew/ButtonNew';

type AuditEventsListType = {
  list: AuditEventType[];
  isLoading: boolean;
  onOpen: (event: AuditEventType) => void;
};

export const AuditEventsList = ({ list = [], isLoading, onOpen }: AuditEventsListType) => {
  return (
    <TableNew noItems='No events match.' itemsCount={list.length} isLoading={isLoading}>
      <>
        <TableHeadNew>
          <TableHeadCellNew name='date_created' hasSort>
            WHEN
          </TableHeadCellNew>
          <TableHeadCellNew>EVENT</TableHeadCellNew>
          <TableHeadCellNew>ACTOR</TableHeadCellNew>
          <TableHeadCellNew>OBJECT</TableHeadCellNew>
          <TableHeadCellNew>DETAIL</TableHeadCellNew>
          <TableHeadCellNew></TableHeadCellNew>
        </TableHeadNew>
        <TableBodyNew>
          {list.map((row) => (
            <TableRowNew key={row.id}>
              <TableCellNew>
                <Typography variant='bodySmall2'>{formatDate(row.date_created, FULL_DATE_TIME_FORMAT)}</Typography>
              </TableCellNew>
              <TableCellNew>
                <Box display='flex' flexDirection='column' gap='4px' alignItems='flex-start'>
                  <Mono>{row.event}</Mono>
                  {row.source !== 'domain' && <SourceTag $source={row.source}>{SOURCE_LABEL[row.source]}</SourceTag>}
                </Box>
              </TableCellNew>
              <TableCellNew>{row.actor_label}</TableCellNew>
              <TableCellNew>
                <Typography variant='bodySmall' fontWeight='medium'>
                  {row.object_label || row.object_type || '-'}
                </Typography>
                {row.transaction_ref && <Mono>{row.transaction_ref}</Mono>}
              </TableCellNew>
              <TableCellNew>
                <Typography variant='bodySmall2'>{row.detail}</Typography>
              </TableCellNew>
              <TableCellNew>
                <ButtonNew variant='secondary' onClick={() => onOpen(row)}>
                  Details
                </ButtonNew>
              </TableCellNew>
            </TableRowNew>
          ))}
        </TableBodyNew>
      </>
    </TableNew>
  );
};
